<template>
  <!--
    O link de um passo do tutorial.

    Quase sempre aponta para o site do parceiro — gerar a chave, criar o
    webhook — e abre em outra aba para não interromper quem está preenchendo o
    formulário. Mas há passos que mandam para outra tela do próprio painel, e
    abrir o painel numa segunda aba faria o usuário terminar com duas cópias do
    sistema, cada uma num estado. Endereço que começa com "/" é daqui, e navega
    aqui mesmo.
  -->
  <router-link v-if="interno" :to="href">
    <slot /> <fa-icon icon="angle-right" />
  </router-link>
  <a
    v-else-if="externoPermitido"
    :href="href"
    target="_blank"
    rel="noopener noreferrer"
  >
    <slot /> <fa-icon icon="angle-right" />
  </a>
  <span v-else class="link-invalido"><slot /></span>
</template>

<script>
import { urlSegura } from '@/helpers/urlSegura';

export default {
  name: 'LinkDoPasso',
  props: {
    href: {
      type: String,
      required: true,
    },
  },
  computed: {
    /*
     * "//" é endereço externo, não caminho daqui: entregue ao router-link ele
     * tiraria o usuário do painel por uma porta que não confere esquema.
     */
    interno() {
      return this.href.startsWith('/') && !this.href.startsWith('//');
    },

    /* O endereço vem do manifesto do conector, e só http(s) vira link. */
    externoPermitido() {
      return !!urlSegura(this.href);
    },
  },
};
</script>

<style scoped>
.link-invalido {
  color: #667085;
}
</style>
